export default function sendEvent(data) {
	if (navigator.doNotTrack === '1') {
		data['Do_not_track'] = true;
	}

	if (navigator.sendBeacon) {
		navigator.sendBeacon(
			'event',
			new Blob([JSON.stringify(data)], { type: 'application/json' }),
		);
	} else {
		fetch('event', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		});
	}
}
exports.sendEvent = sendEvent;
